<template>
  <v-layout class="ml-5" row wrap>
    <template v-for="(term, index) in researchQuestionProcessed" >
<!--        v-if="term.isShowing"-->
      <WordTag
        v-if="term.isShowing"
        :key="term.phrase[0] + generateUuid()"
        :text="processTerm(term.phrase)"
        :selected="term.isFacet"
        @click="handleWordClick(term.phrase)"
        @handleSplitTerms="handleSplitTerms($event, term.phrase)"
        :animated="triggerAnimation"
      ></WordTag>
<!--     @todo - disables character animation    -->
<!--        v-if="index !== researchQuestionProcessed.length - 1 && term.isShowing"-->
      <GroupingIcon
        v-if="index !== researchQuestionProcessed.length - 1 && term.isShowing"
        :key="index + generateUuid()"
        @click="handleGroupTerms(term.phrase)"
      ></GroupingIcon>
    </template>
  </v-layout>
</template>
<script>
import {GroupingIcon, WordTag} from '../utils/buttons'
import {shortUuid} from '../../../utils/uuid'

export default {
  name: 'AnimatedKeyConcepts',
  components: {GroupingIcon, WordTag},
  computed: {
    researchQuestionProcessed: { get () { return this.$store.getters.getResearchQuestionProcessed } },
    animationSpeed: { get () { return this.$store.getters.getAnimationSpeed } },
    triggerAnimation: {
      get () { return this.$store.getters.getKeyConceptsSectionState.triggerAnimation }
    }
  },
  mounted () {
    if (this.triggerAnimation) {
      this.researchQuestionProcessed.forEach((term, index) => {
        this.animatedShowConcepts(index)
      })
      this.$store.commit('setKeyConceptSectionAnimation', false)
    } else {
      this.researchQuestionProcessed.forEach((term, index) => {
        this.researchQuestionProcessed[index].isShowing = true
      })
    }
  },
  methods: {
    generateUuid () {
      return '-' + shortUuid()
    },
    processTerm (term) {
      if (Array.isArray(term)) {
        return term
      }
      return term.split(' ').filter(el => el !== '')
    },
    animatedShowConcepts (index) {
      const delay = this.animationSpeed * index
      setTimeout(() => {
        this.researchQuestionProcessed[index].isShowing = true
      }, delay)
    },
    handleWordClick (word) {
      this.$store.dispatch('handleWordClick', word)
    },
    handleGroupTerms (word) {
      this.$store.dispatch('handleGroupTerms', word)
    },
    handleSplitTerms (index, word) {
      const splitIndex = index + 1
      this.$store.dispatch('handleSplitTerms', {splitIndex, word})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/parts/searchAi/AnimatedKeyConcepts.vue